import html2canvas from 'html2canvas/dist/html2canvas.min';
import jspdf from 'jspdf/dist/jspdf.min';
// import pdfmake from 'pdfmake/build/pdfmake.min';
// import vfs_fonts from 'pdfmake/build/vfs_fonts';


// modes: 
// batching => 批次處理中
// doBatchExport => 最後一批次處理，並輸出pdf
// 批次匯出時，第1筆開始mode為batching，最後一筆mode為doBatchExport，整個過程batchStock都要傳入
export default function exportPDF(jqElecontainers, fileName = "exportedPDF", cb, mode, batchStock) {

  if (!jqElecontainers) { return; }

  // 先將html元素用 scale 放大後，再用canvas截圖即可提高解析度
  // 高解析縮小尺寸更顯清晰
  // 相對的檔案會變大，取平衡
  // 需與html scale 倍數相同
  const scale = 2,
    // a4 寬、高
    displayWidth = 595.28,
    displayheight = 841.89,
    // jQuery 建立物件時特意模擬陣列，所以有設定length屬性，
    len = jqElecontainers.length;

  let arrDataURL = [];

  // 定義截圖遞迴函式
  function forRecursive(i) {
    html2canvas(jqElecontainers[i], { width: displayWidth * scale, height: displayheight * scale })
      .then((canvas) => {
        // 返回圖片dataURL,參數: 品片格式和清晰度(0~1)
        arrDataURL.push(canvas.toDataURL('image/jpeg', 1.0));

        // 截圖結束，產生pdf
        if (++i === len) {
          if (mode === 'batching') {
            // 批次模式
            batchStock.push(...arrDataURL);
          } else {
            // 單筆模式
            // 方向預設直向，尺寸單位points，格式a4[595.28, 841.89]

            // 批次處理最後一批情況
            if (mode === 'doBatchExport') {
              batchStock.push(...arrDataURL);
              arrDataURL = batchStock;
            }

            const pdf = new jspdf('', 'pt', 'a4'),
              len = arrDataURL.length;

            // addImage後兩個參數控制加入圖片的尺寸，此處以a4寬度縮放
            // 首頁
            pdf.addImage(arrDataURL[0], 'JPEG', 0, 0, displayWidth, displayheight);
            // 第2頁開始
            for (let i = 1; i < len; i++) {
              pdf.addPage();
              pdf.addImage(arrDataURL[i], 'JPEG', 0, 0, displayWidth, displayheight);
            }
            // 輸出pdf
            pdf.save(fileName + '.pdf');

          }

          if (cb) cb();
          return;
        }

        forRecursive(i);
      })
      .catch((error) => { });
  }

  // 從0開始執行截圖函式
  forRecursive(0);

}



// WEBPACK FOOTER //
// ./src/commonJS/exportPDF.js